export default __webpack_public_path__ + "static/media/dialog_warning.70d03676.svg";